module.exports = __webpack_public_path__ + "img/9788990878243.25027d31.jpg";